import DevLog from '../modules/devlog/Module'
import { DEBUG_CLIENT } from '../modules/client/const'
import HooksModule from '../modules/hooks/Module'

export const selection = () => {
  if (HooksModule.hasHapticHook) HooksModule.haptic('selection')
  if (DEBUG_CLIENT) DevLog._log(`SW[Haptic]:`, 'selection')
}

export const soft = () => {
  if (HooksModule.hasHapticHook) HooksModule.haptic('soft')
  if (DEBUG_CLIENT) DevLog._log(`SW[Haptic]:`, 'soft')
}

export const success = () => {
  if (HooksModule.hasHapticHook) HooksModule.haptic('success')
  if (DEBUG_CLIENT) DevLog._log(`SW[Haptic]:`, 'success')
}

export const error = () => {
  if (HooksModule.hasHapticHook) HooksModule.haptic('error')
  if (DEBUG_CLIENT) DevLog._log(`SW[Haptic]:`, 'error')
}

export const hapticEffects = { selection, soft, success, error }
